/*
    This script defines the base url that the frontend is to make reuqests to
*/

const api = window.location.host.includes("localhost")
  ? "http://localhost:8010/proxy"
  : `https://api.${window.location.host}`

export default api
